"use client";
import { useEffect, useState } from "react";

const KEY = "fablio_cookie_ack";

export function CookieBanner() {
  const [show, setShow] = useState(false);
  const [pl, setPl] = useState(false);
  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setShow(true);
      setPl((navigator.language || "").toLowerCase().startsWith("pl"));
    } catch {}
  }, []);
  if (!show) return null;
  const txt = pl
    ? "Używamy wyłącznie ciasteczek funkcjonalnych (język, waluta, motyw, polecenia)."
    : "We use only functional cookies (language, currency, theme, referrals).";
  const more = pl ? "Polityka prywatności" : "Privacy";
  const href = pl ? "/polityka-prywatnosci" : "/privacy";
  return (
    <div style={{ position: "fixed", bottom: 12, left: 12, right: 12, maxWidth: 560, margin: "0 auto", background: "#1b1430", color: "#fff", borderRadius: 14, padding: "14px 16px", fontSize: 13, display: "flex", gap: 12, alignItems: "center", zIndex: 9999, boxShadow: "0 8px 30px rgba(0,0,0,.35)" }}>
      <span style={{ flex: 1 }}>
        {txt} <a href={href} style={{ color: "#c9b8ff", textDecoration: "underline" }}>{more}</a>
      </span>
      <button
        onClick={() => { try { localStorage.setItem(KEY, "1"); } catch {} setShow(false); }}
        style={{ background: "#6c4cf0", color: "#fff", border: "none", borderRadius: 50, padding: "8px 20px", cursor: "pointer", fontWeight: 600 }}
      >OK</button>
    </div>
  );
}
